import { Schema } from '@core/data/dto/schema';

export const DeliveryOrderQuoteManagerSchema = {
    id: Schema.String,
    name: Schema.String,
    avatar_url: Schema.String,
    vehicle_type: Schema.Auto,
    timecard_id: Schema.String,
    timecard_status: Schema.Auto,
    config: Schema.Boolean,
};
